import { render, staticRenderFns } from "./wsnham.vue?vue&type=template&id=38a367ea&scoped=true&"
import script from "./wsnham.vue?vue&type=script&lang=js&"
export * from "./wsnham.vue?vue&type=script&lang=js&"
import style0 from "./wsnham.vue?vue&type=style&index=0&id=38a367ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a367ea",
  null
  
)

export default component.exports